{
  "version": 1,
  "asset_id": "c9cf13ca-f74f-4ed7-9973-a7790bc51e32",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/c9cf13ca-f74f-4ed7-9973-a7790bc51e32/rv_accessories.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/c9cf13ca-f74f-4ed7-9973-a7790bc51e32/rv_accessories.webp",
  "original_filename": "rv_accessories.webp",
  "size": 42782,
  "content_type": "image/webp",
  "created_at": "2026-07-14T02:53:15Z"
}
